'use client';

import { useEffect } from 'react';
import { useMultistepForm } from '../../../../form-controls/MultistepForm/hooks/useMultistepForm';

type BackHandlerProps = {
  onStepInfo: (currentStepIndex: number, goBack: () => void) => void;
};

function BackHandler({ onStepInfo }: BackHandlerProps) {
  const { currentStepIndex, goToPreviousStep } = useMultistepForm();

  useEffect(() => {
    onStepInfo(currentStepIndex, goToPreviousStep);
  }, [currentStepIndex, goToPreviousStep, onStepInfo]);

  return null;
}

export { BackHandler };
